
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSpinner,
    IonIcon,
    IonButton,
    modalController,
    IonButtons,
    menuController,
    onIonViewWillEnter,
} from "@ionic/vue";
import { add, refresh, menu } from "ionicons/icons";

import { ref, computed, onMounted } from "vue";
import { Calendar } from "v-calendar";

import { LOCALSTORAGE_KEY } from "@/custom_config";

import moment from "moment";
import "moment/locale/it";

import { openToast } from "@/services/toast";
import apiRichieste from "@/services/richieste";
import apiImpostazioniHr from "@/services/impostazioni_hr";

import ModalNuovaDispIndisp from "@/components/richieste/ModalNuovaDispIndisp.vue";
import RichiestaDetail from "@/components/richieste/RichiestaDetail.vue";

export default {
    name: "DispIndisp",
    components: {
        IonHeader,
        IonToolbar,
        IonTitle,
        IonContent,
        IonPage,
        IonSpinner,
        IonIcon,
        IonButton,
        IonButtons,
        Calendar,
    },
    setup() {
        const loading = ref(false);
        const richieste = ref([]);
        const richiesteToShow = ref([]);

        const dipendenteID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_id;

        const openMenu = () => {
            menuController.open("app-menu");
        };

        const dataRichiesta = computed(() => {
            return (dataInizio, dataFine) => {
                const inizio = moment(dataInizio).format("DD/MM/YYYY");
                const fine = moment(dataFine).format("DD/MM/YYYY");
                if (!moment(dataFine).isValid()) {
                    return `Dal ${inizio}`;
                } else if (inizio == fine) {
                    return `${inizio}`;
                } else {
                    return `Dal ${inizio} al ${fine}`;
                }
            };
        });

        const dateLabel = (value) => {
            return moment(value).locale("it").format("dddd DD/MM/YYYY");
        };

        /**
         *
         * ! Tab switcher
         *
         */
        const showCalendar = ref(true);
        const showList = ref(false);
        const selectedTab = ref(1);

        function setActiveTab(id) {
            selectedTab.value = id;
            showCalendar.value = id === 1;
            showList.value = id === 2;
        }

        /**
         *
         * ! Calendar data
         *
         */
        const date = ref(new Date());
        const selectedDay = ref(null);

        function getDefaultModalDate() {
            if (selectedDay.value && selectedDay.value.id) {
                return selectedDay.value.id;
            }
            return date.value;
        }

        function isValidDate(value) {
            return value && moment(value).isValid();
        }

        function getRichiesteForDate(targetDate) {
            const dayStart = moment(targetDate).startOf("day");
            const dayEnd = moment(targetDate).endOf("day");

            return richieste.value.filter((richiesta) => {
                const dal = moment(richiesta.richieste_dal).startOf("day");
                const al = isValidDate(richiesta.richieste_al) ? moment(richiesta.richieste_al).endOf("day") : dal.clone().endOf("day");
                return dal.isSameOrBefore(dayEnd) && al.isSameOrAfter(dayStart);
            });
        }

        function getRichiestaTipologiaId(richiesta) {
            const raw =
                richiesta.richieste_tipologia != null ? richiesta.richieste_tipologia : richiesta.richieste_tipologia_id;
            return Number(raw);
        }

        /**
         * Per ogni giorno coperto da almeno una richiesta: flag disponibilità (6) / indisponibilità (7).
         */
        function buildDayDispIndispFlags(list) {
            const dayMap = {};
            list.forEach((richiesta) => {
                const tipologiaId = getRichiestaTipologiaId(richiesta);
                if (tipologiaId !== 6 && tipologiaId !== 7) {
                    return;
                }
                const start = moment(richiesta.richieste_dal).startOf("day");
                const end = isValidDate(richiesta.richieste_al)
                    ? moment(richiesta.richieste_al).startOf("day")
                    : start.clone();
                for (let d = start.clone(); d.isSameOrBefore(end); d.add(1, "day")) {
                    const key = d.format("YYYY-MM-DD");
                    if (!dayMap[key]) {
                        dayMap[key] = { disp: false, indisp: false };
                    }
                    if (tipologiaId === 6) {
                        dayMap[key].disp = true;
                    }
                    if (tipologiaId === 7) {
                        dayMap[key].indisp = true;
                    }
                }
            });
            return dayMap;
        }

        /**
         * Colori pallino: solo token supportati da v-calendar (stringa esatta).
         * gray, red, orange, yellow, green, teal, blue, indigo, purple, pink
         */
        function calendarDotColor(flags) {
            if (flags.disp && flags.indisp) {
                return "yellow";
            }
            if (flags.indisp && !flags.disp) {
                return "red";
            }
            return "green";
        }

        const calendarAttributes = computed(() => {
            const todayStr = moment().format("YYYY-MM-DD");
            const dayMap = buildDayDispIndispFlags(richieste.value);
            const attrs = Object.keys(dayMap)
                .sort()
                .map((dayStr) => ({
                    key: `disp-indisp-${dayStr}`,
                    dates: moment(dayStr, "YYYY-MM-DD").toDate(),
                    highlight: {
                        color: calendarDotColor(dayMap[dayStr]),
                        fillMode: "solid",
                    },
                }));

            // Oggi senza alcuna disp/indisp: pallino base (v-calendar richiede il nome token)
            if (!dayMap[todayStr]) {
                attrs.push({
                    key: `disp-indisp-oggi-base-${todayStr}`,
                    dates: moment(todayStr, "YYYY-MM-DD").toDate(),
                    highlight: {
                        color: "blue",
                        fillMode: "solid",
                    },
                });
            }

            return attrs;
        });

        const dayClicked = (day) => {
            selectedDay.value = day;
            richiesteToShow.value = getRichiesteForDate(day.id);
        };

        /*********************************************
         *
         * ! Get all richieste
         *
         ********************************************/
        async function loadRichieste() {
            loading.value = true;
            try {
                const res = await apiRichieste.getDispIndisp(dipendenteID);
                if (res.status === 200 && res.data.status === 0) {
                    richieste.value = [];
                    richieste.value = res.data.data;
                    richiesteToShow.value = getRichiesteForDate(moment());
                } else {
                    openToast("Si è verificato un errore durante la richiesta dei dati", "toast_danger");
                }
            } catch (error) {
                console.error(error);
                openToast("Errore durante la richiesta dei dati", "toast_danger");
            }
            loading.value = false;
        }
        // loadRichieste();


        /*********************************************
         *
         * ! Open modal to create new richiesta
         *
         ********************************************/
        async function openModal(tipologiaDefault?: string, dataDefault?: any) {
            const modal = await modalController.create({
                component: ModalNuovaDispIndisp,
                componentProps: {
                    tipologiaDefault,
                    dataDefault,
                },
            });
            modal.onDidDismiss().then((detail) => {
                if (detail.data != undefined) {
                    // richieste.value = [detail.data, ...richieste.value];
                    // Devo richiedere i dati nuovamente per aggiornare la lista
                    openToast("La richiesta è stata inserita con successo", "toast_success");
                    loadRichieste();
                }
            });
            return modal.present();
        }

        //Set correct background for richieste status
        const statoRichiesta = computed(() => {
            return (statusId) => {
                let className = "";
                if (statusId == 1) {
                    //attesa approvazione
                    className = "badge_warning";
                } else if (statusId == 2) {
                    //approvato
                    className = "badge_success";
                } else if (statusId == 3) {
                    //rifiutato
                    className = "badge_danger";
                }
                return className;
            };
        });

        //Set correct background for richieste status
        const setBackground = computed(() => {
            return (statusId) => {
                let className = "";
                if (statusId == 1) {
                    //permesso
                    className = "permesso";
                } else if (statusId == 2) {
                    //ferie
                    className = "ferie";
                } else if (statusId == 3) {
                    //malattia
                    className = "malattia";
                } else if (statusId == 4) {
                    //smart working
                    className = "smart_working";
                } else if (statusId == 5) {
                    //trasferta
                    className = "trasferta";
                } else if (statusId == 6 || statusId == 7) {
                    //trasferta
                    className = "disponibilita";
                }
                return className;
            };
        });

        /*********************************************
         *
         * ! Passing id to retrive detail in RichiestaDetail page
         *
         ********************************************/
        async function openRichiestaDetail(richiestaDetail) {
            const modal = await modalController.create({
                component: RichiestaDetail,
                componentProps: {
                    data: richiestaDetail,
                },
            });
            modal.onDidDismiss().then((detail) => {
                if (detail.data && detail.data.revoked) {
                    loadRichieste();
                    // openToast("Richiesta revocata", "toast_success");
                } else if (detail.data != undefined) {
                    richieste.value = [detail.data, ...richieste.value];
                    openToast("Nuova richiesta inserita", "toast_success");
                }
            });
            return modal.present();
        }


        /*********************************************
         *
         * ! Get module settings
         *
         ********************************************/
        const nascondiDisponibilita = ref(false);
        const nascondiIndisponibilita = ref(false);
         async function loadModuleSettings() {
            try {
                const res = await apiImpostazioniHr.getImpostazioniHr();
                console.log(res);
                
                if (res.status === 200 && res.data.status === 0) {
                    const data = res.data.data[0];
                    nascondiDisponibilita.value = data.impostazioni_hr_nascondi_disp == 1 ? true : false;
                    nascondiIndisponibilita.value = data.impostazioni_hr_nascondi_indisp == 1 ? true : false;
                } else {
                    openToast("Si è verificato un errore durante la richiesta dei dati", "toast_danger");
                }
            } catch (error) {
                console.error(error);
                openToast("Errore durante la richiesta dei dati", "toast_danger");
            }
        }
        
        
        onMounted(() => {
            loadModuleSettings();
            loadRichieste();
        });

        return {
            loading,
            add,
            refresh,
            //openDetail,
            openModal,
            richieste,
            statoRichiesta,
            //New field
            loadRichieste,
            openRichiestaDetail,
            dataRichiesta,
            dateLabel,
            openMenu,
            menu,
            setBackground,
            // Calendar
            showCalendar,
            showList,
            selectedTab,
            setActiveTab,
            date,
            selectedDay,
            calendarAttributes,
            dayClicked,
            richiesteToShow,
            getDefaultModalDate,
            // Settings flag
            nascondiDisponibilita,
            nascondiIndisponibilita,
        };
    },
};
